module.exports = __webpack_public_path__ + "static/media/correct.a17b42f7.svg";